/* UC marketing attribution. Never sends contact details or treats iframe loading as signup. */
(() => {
  if (window.__ucTracking) return;
  window.__ucTracking = true;
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const storageKey = 'uc_attribution_v1';
  const maxAge = 30 * 24 * 60 * 60 * 1000;
  const consent = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const incoming = {};
  const params = new URLSearchParams(location.search);
  keys.forEach(key => {
    const value = params.get(key);
    if (value && /^[a-zA-Z0-9 _.,~+-]{1,100}$/.test(value)) incoming[key] = value;
  });
  let attribution = null;
  const layloOrigin = 'https://embed.laylo.com';
  const sendLayloAttribution = frame => {
    if (!consent() || !attribution?.last || !frame?.contentWindow) return;
    const page = new URL(location.pathname, location.origin);
    keys.forEach(key => { if (attribution.last[key]) page.searchParams.set(key, attribution.last[key]); });
    // Uses the same metadata message as Laylo's official SDK, without changing internal URLs.
    frame.contentWindow.postMessage({ type: 'setWindowMetadata', payload: {
      href: page.href, hostname: location.hostname, path: location.pathname, title: document.title
    } }, layloOrigin);
  };
  window.addEventListener('message', event => {
    if (event.origin !== layloOrigin || !event.data?.dropLoaded || typeof event.data.dropId !== 'string') return;
    const frame = document.getElementById(`laylo-drop-${event.data.dropId}`);
    if (!frame || frame.contentWindow !== event.source) return;
    setTimeout(() => sendLayloAttribution(frame), 0);
  });
  const synchronize = () => {
    if (!consent()) {
      attribution = null;
      try { localStorage.removeItem(storageKey); } catch (_) { /* Storage unavailable. */ }
      return;
    }
    try { attribution = JSON.parse(localStorage.getItem(storageKey)); } catch (_) { attribution = null; }
    if (!attribution?.createdAt || Date.now() - attribution.createdAt > maxAge) {
      attribution = null;
      try { localStorage.removeItem(storageKey); } catch (_) { /* Storage unavailable. */ }
    }
    if (Object.keys(incoming).length) {
      const touch = { ...incoming, landing_path: location.pathname };
      attribution = attribution || { createdAt: Date.now(), first: touch };
      attribution.last = touch;
    }
    if (attribution) {
      try { localStorage.setItem(storageKey, JSON.stringify(attribution)); } catch (_) { /* Continue without persistence. */ }
    }
  };
  const publish = (event, properties) => {
    if (!consent() || window.Shopify?.designMode) return;
    const payload = { ...properties, page_path: location.pathname, attribution };
    window.Shopify?.analytics?.publish?.(event, payload);
    if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...payload });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-uc-cta]');
    if (!link) return;
    if (consent() && attribution?.last && link.href) {
      const destination = new URL(link.href, location.origin);
      if (destination.hostname === 'laylo.com' && destination.pathname.startsWith('/underconstruction')) {
        keys.forEach(key => { if (attribution.last[key] && !destination.searchParams.has(key)) destination.searchParams.set(key, attribution.last[key]); });
        link.href = destination.href;
      }
    }
    publish('uc_cta_clicked', { cta: link.dataset.ucCta, signup_goal: link.closest('[data-uc-signup]')?.dataset.ucSignup || null });
  });
  const observed = new WeakSet();
  const seen = new WeakSet();
  const observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || seen.has(entry.target) || !consent()) return;
      seen.add(entry.target);
      publish('uc_signup_form_viewed', { signup_goal: entry.target.dataset.ucSignup, laylo_drop_id: entry.target.dataset.ucDropId });
    });
  }, { threshold: 0.25 }) : null;
  const initialize = () => {
    synchronize();
    document.querySelectorAll('[data-uc-signup]').forEach(section => {
      if (!observed.has(section)) { observed.add(section); observer?.observe(section); }
    });
  };
  document.addEventListener('visitorConsentCollected', () => {
    synchronize();
    document.querySelectorAll('iframe[data-uc-laylo-embed]').forEach(sendLayloAttribution);
    document.querySelectorAll('[data-uc-signup]').forEach(section => { observer?.unobserve(section); observer?.observe(section); });
  });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) initialize(); });
  }
})();
